import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The candidate tabs. An identity with no candidate profile has none of them,
 * so a link to one lands on its Accounts tab instead.
 */
export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate',
)({
  beforeLoad: ({ context, params }) => {
    if (!context.candidate) {
      throw redirect({
        params: { identityId: params.identityId },
        replace: true,
        to: '/people/$identityId/accounts',
      });
    }
    return { candidate: context.candidate };
  },
});
